<template>
  <div>
    <div
      class="silder-contain"
      :class="Userlist.containClass"
      @click="
        recordShow = false;
        recommendPopVisable = false;
      "
    >
      <div class="slider-top clearFloat slider-top-create">
        <p class="h3 slider-title pull-left">{{ Userlist.sliderTitle }}</p>
        <div
          class="pull-right h1 btn-close font-gray"
          @click="hideUserSliderBox"
        >
          <i class="el-icon-close"></i>
        </div>
        <el-button type="primary" class="pull-right" @click="onSubmit()">{{
          $t("Common.btn_submit")
        }}</el-button>
      </div>

      <div class="slider-cont text-1 slider-create-edit">
        <div class="slider-person-info">
          <el-upload
            class="avatar-uploader person-img"
            :action="$uploadAction('/Uploading/Picture')"
            name="ossfile"
            :data="Uploadimg"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <img v-else :src="photoImg" />
          </el-upload>
          <div class="btn-upload">
            <span>{{ $t("User.img_text1") }}</span>
            <!-- <input type="file"> -->
            <el-upload
              class="btn-avatar-uploader"
              :action="$uploadAction('/Uploading/Picture')"
              name="ossfile"
              :data="Uploadimg"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <img v-else :src="photoImg" />
            </el-upload>
          </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <!-- <p class="form-small-title h3">{{$t('User.s_title1')}}</p> -->
          <div class="pop-container--form">
            <div class="from-head--lf">
              <el-form-item
                :label="$t('User.label_text1')"
                class="tag-must"
                prop="client_cnname"
              >
                <el-input
                  v-model="form.client_cnname"
                  style="width: 358px"
                  :placeholder="$t('User.placeholder1')"
                  @blur="checkIntentionClientData(form)"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('User.label_text2')">
                <el-input
                  v-model="form.client_enname"
                  style="width: 358px"
                  :placeholder="$t('User.placeholder2')"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('User.label_text3')"
                class="tag-must"
                prop="client_sex"
              >
                <el-select
                  filterable
                  v-model="form.client_sex"
                  style="width: 358px"
                  :placeholder="$t('User.placeholder3')"
                >
                  <el-option
                    :label="$t('User.man')"
                    :value="$t('User.man')"
                  ></el-option>
                  <el-option
                    :label="$t('User.woman')"
                    :value="$t('User.woman')"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 手机号 -->
              <el-form-item
                :label="$t('User.label_text4')"
                :class="[isEdit ? '' : 'tag-must']"
                :prop="isEdit ? '' : 'client_mobile'"
              >
                <el-input
                  v-model="form.client_mobile"
                  style="width: 358px"
                  :placeholder="$t('User.placeholder4')"
                  :disabled="isEdit && form.company_iscrmmoblie == 0"
                  @input="
                    InputPhone(),
                      checkIntentionClientData(form),
                      (isClickChangeStudentType = false)
                  "
                  @blur="BlurPhone()"
                ></el-input>
                <span v-if="isrepeatUser" class="error-tip" @click.stop>
                  {{ $t("User.tips1") }}
                  <i class="el-icon-question" @click="recordHide"></i>
                </span>
              </el-form-item>
              <el-form-item
                label=""
                v-if="
                  !isEdit &&
                  isrepeatUser &&
                  companyId === '8888' &&
                  !isClickChangeStudentType
                "
              >
                <div class="flex-al">
                  <span>非同胞学员禁止录入重复手机，是否确认为同胞学员？</span>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="modifyStudentType"
                    >确定</el-button
                  >
                </div>
              </el-form-item>
              <!-- 出生日期 -->
              <el-form-item
                :label="$t('User.label_text5')"
                prop="client_birthday"
              >
                <el-date-picker
                  type="date"
                  :placeholder="$t('User.placeholder5')"
                  v-model="form.client_birthday"
                  style="width: 358px"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
              <!-- //OH月 -->
              <!-- <el-form-item label="OH月份：">
              <el-date-picker
                type="month"
                placeholder="选择OH月份"
                v-model="form.client_oh_month"
                style="width: 358px;"
                value-format="yyyy-MM"
              ></el-date-picker>
            </el-form-item>-->
              <!-- //PUSh月 -->
              <!-- <el-form-item label="PUSH月份：">
              <el-date-picker
                type="month"
                placeholder="选择PUSH月份"
                v-model="form.client_push_month"
                style="width: 358px;"
                value-format="yyyy-MM"
              ></el-date-picker>
            </el-form-item>-->
              <!-- 省市区 -->
              <el-form-item :label="$t('User.label_text18_5')" required>
                <el-col :span="5">
                  <el-form-item prop="province_id">
                    <el-select
                      filterable
                      v-model="form.province_id"
                      :placeholder="$t('User.label_text18_5_ph1')"
                      style="width: 100%"
                      @change="changeProvince"
                    >
                      <el-option
                        v-for="(item, index) of provinceList"
                        :key="`${index}${item.region_id}`"
                        :label="item.region_name"
                        :value="item.region_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5" class="select-city">
                  <el-form-item prop="city_id">
                    <el-select
                      filterable
                      v-model="form.city_id"
                      :placeholder="$t('User.label_text18_5_ph2')"
                      style="width: 100%"
                      @change="changeCity"
                    >
                      <el-option
                        v-for="(item, index) of cityList"
                        :key="`${index}${item.region_id}`"
                        :label="item.region_name"
                        :value="item.region_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item prop="area_id">
                    <el-select
                      filterable
                      v-model="form.area_id"
                      :placeholder="$t('User.label_text18_5_ph3')"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) of areaList"
                        :key="`${index}${item.region_id}`"
                        :label="item.region_name"
                        :value="item.region_id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item :label="$t('User.label_text6')">
                <el-input
                  v-model="form.client_icard"
                  style="width: 358px"
                  :placeholder="$t('User.placeholder6')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('User.label_text18_4')">
                <el-select
                  filterable
                  v-model="form.nearschool_id"
                  :placeholder="$t('User.label_text18_4_ph')"
                  style="width: 358px"
                >
                  <el-option
                    v-for="(item, index) of nearschoolList"
                    :key="`${index}${item.nearschool_id}`"
                    :label="item.nearschool_name"
                    :value="item.nearschool_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('User.ae')" class="form-item-tag">
                <div class="tag-list">
                  <span
                    v-for="(item, index) in form.client_tags"
                    :key="index"
                    class="tagItem"
                  >
                    {{ item }}
                  </span>
                </div>
                <div class="addTagBtn ml10" @click="addTagVisable = true">
                  {{ $t("User.ab") }}
                </div>
              </el-form-item>
              <!-- client_tags -->
            </div>

            <!-- 重复记录列表 -->
            <div v-if="recordShow" class="repeat-record" @click.stop>
              <div class="record-top clearFloat">
                <span class="h3">{{ $t("User.s_title2") }}</span>
                <div
                  class="pull-right h1 btn-close font-gray"
                  @click="recordShow = false"
                >
                  <i class="el-icon-close"></i>
                </div>
              </div>
              <div class="record-cont">
                <div
                  class="record-item"
                  v-for="(item, index) in repeatList"
                  :key="index"
                >
                  <p class="clearFloat">
                    <span class="name">
                      {{ item.client_cnname }}
                      <img v-if="item.client_sex == '男'" :src="manImg" />
                      <img v-if="item.client_sex == '女'" :src="womanImg" />
                    </span>
                    <span
                      >{{ item.client_age }}{{ $t("User.record_text1") }}</span
                    >

                    <!-- disabled -->
                    <!--   span =>
                    !((item.isgmcIndschoolenter == 1 &&
                          item.isgmcschoolenter != 1) || item.client_tracestatus == 4 || item.client_tracestatus == -2 || item.client_tracestatus == -1) -->

                    <!-- click => !(
                          item.isgmcIndschoolenter == 1 &&
                          item.isgmcschoolenter != 1
                        ) && item.client_tracestatus != 4 && item.client_tracestatus == -2 && item.client_tracestatus == -1 -->
                    <span
                      class="btn-track pull-right"
                      :class="{
                        'btn-track-active': item.is_track == 1,
                      }"
                      @click="item.is_track == 1 ? wantToTrack(item) : ''"
                      >{{ item.track_stuname }}</span
                    >
                  </p>
                  <template>
                    <p class="small-tip">
                      <span
                        >{{ $t("User.record_text2")
                        }}{{ item.marketer_name }}</span
                      >
                      <span class="tip-school">{{ item.school_cnname }}</span>
                    </p>
                    <p class="small-tip">
                      <span>
                        {{ $t("User.record_text3") }}
                        {{ item.client_tracestatus_name }}
                      </span>
                    </p>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- 家庭联系信息 -->
          <p class="form-small-title h3">{{ $t("User.s_title3") }}</p>
          <div class="family-info">
            <el-radio-group v-model="family_radio">
              <div
                class="family-list-info"
                v-for="(item, index) in familyNum"
                :key="index"
              >
                <!-- <div class="f-label-title">{{ item.title }}</div> -->
                <el-form-item class="relation">
                  <el-select
                    filterable
                    v-model="item.family_relation"
                    :placeholder="$t('User.placeholder7_1')"
                    clearable
                  >
                    <el-option
                      v-for="(item2, index2) in FamilyRelation"
                      :key="index2"
                      :label="item2.familyrelation_name"
                      :value="item2.familyrelation_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="name">
                  <el-input
                    v-model="item.family_cnname"
                    :placeholder="$t('User.placeholder7_2')"
                  ></el-input>
                </el-form-item>
                <el-form-item class="mobile mr10">
                  <!-- <el-input v-model="item.family_mobile" placeholder="请输入手机号"  @blur="checkPhoneNumber(item.family_mobile,index)"></el-input> -->
                  <el-input
                    :disabled="
                      isEdit &&
                      form.company_iscrmmoblie == 0 &&
                      !!item.family_mobile &&
                      currentDisabledIndex == index &&
                      !item.clickAdd
                    "
                    v-model="item.family_mobile"
                    :placeholder="$t('User.placeholder7_3')"
                  ></el-input>
                  <!-- <p v-if="errorTip1[index]=='1'" class="family-error error1">手机号不能为空</p>
                <p v-if="errorTip2[index]=='1'" class="family-error error2">请输入正确的手机号</p>-->
                </el-form-item>
                <el-form-item class="mobile mr10">
                  <el-input
                    v-model="item.family_wechat"
                    placeholder="请输入微信号"
                  ></el-input>
                </el-form-item>
                <el-form-item class="mobile">
                  <el-input
                    v-model="item.family_email"
                    placeholder="请输入Email"
                  ></el-input>
                </el-form-item>
                <el-radio :label="index" disabled class="isdefault">
                  {{ $t("User.btn_text1") }}
                </el-radio>
                <span
                  v-if="item.family_isdefault == 0"
                  class="btn-delete"
                  @click="Clickdelete(index)"
                >
                  <i class="el-icon-remove-outline"></i>
                </span>
                <!-- 是否确认删除 -->
                <div
                  v-if="isdelete && isdeleteindex == index"
                  class="cofirm-delete"
                >
                  <div class="delete-top">{{ $t("Common.tips") }}</div>
                  <div class="delete-cont">
                    <p>{{ $t("Common.delTips") }}</p>
                  </div>
                  <div class="delete-footer">
                    <el-button
                      type="primary"
                      @click="deleteFamily(item, index)"
                      >{{ $t("Common.btn_confirm") }}</el-button
                    >
                    <el-button @click="handledeleteClose">{{
                      $t("Common.btn_cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </el-radio-group>

            <div class="add-info">
              <span @click="addFamily">
                <i class="el-icon-circle-plus"></i>
                {{ $t("User.btn_text2") }}
              </span>
            </div>
          </div>
          <p class="form-small-title h3">{{ $t("User.s_title4") }}</p>
          <div class="enrollment-info">
            <el-form-item :label="$t('User.label_text8')">
              <el-select
                filterable
                v-model="form.client_fromtype"
                clearable
                style="width: 358px"
                :placeholder="$t('User.placeholder8')"
              >
                <el-option
                  :label="$t('User.options1[0]')"
                  value="0"
                ></el-option>
                <el-option
                  :label="$t('User.options1[1]')"
                  value="1"
                ></el-option>
                <el-option
                  :label="$t('User.options1[2]')"
                  value="2"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 招生渠道信息 -->
            <el-form-item :label="$t('User.label_text9')" prop="client_source">
              <!-- || isClickChangeStudentType -->
              <el-select
                filterable
                v-model="form.client_source"
                clearable
                :disabled="isEdit || isClickChangeStudentType"
                style="width: 358px"
                :placeholder="$t('User.placeholder9')"
                @change="
                  (showPromotionJobnumber = false),
                    (form.promotion_id = ''),
                    selectSource()
                "
              >
                <el-option
                  v-for="item in SchoolsourceOption"
                  :key="item.frommedia_id"
                  :label="item.frommedia_name"
                  :value="item.frommedia_name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('User.label_text10')" prop="channel_id">
              <el-select
                filterable
                v-model="form.channel_id"
                clearable
                :disabled="isEdit || isClickChangeStudentType"
                style="width: 358px"
                :placeholder="$t('User.placeholder10')"
                @change="onChangeChannelId"
              >
                <el-option
                  v-for="item in ChannelOption"
                  :key="item.channel_id"
                  :label="item.channel_name"
                  :value="item.channel_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="地推工号："
              prop="promotion_id"
              v-if="showPromotionJobnumber"
            >
              <!-- <el-input
                v-model="form.promotion_id"
                style="width: 358px"
                placeholder="请输入地推工号"
              >
              </el-input> -->
              <el-select
                filterable
                v-model="form.promotion_id"
                style="width: 340px"
                placeholder="请输入地推工号"
                reserve-keyword
                remote
                :remote-method="remotePromotion"
                :loading="loading"
              >
                <el-option
                  v-for="item in groundPromotionList"
                  :key="item.promotion_id"
                  :label="`${item.promotion_name}（${item.promotion_jobnumber}）`"
                  :value="item.promotion_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('User.label_text11')" v-if="false">
              <el-rate
                v-if="!isEdit"
                v-model="intention_level"
                show-text
                :texts="intentionLevelList"
                class="rate-startLevel rate-startLevel-diy"
                :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                void-icon-class="crm-like"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              ></el-rate>
              <el-rate
                v-if="isEdit"
                v-model="num"
                show-text
                :texts="intentionLevelList"
                class="rate-startLevel rate-startLevel-diy"
                :icon-classes="['crm-likes', 'crm-likes', 'crm-likes']"
                void-icon-class="crm-like"
                score-template="{value}"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              ></el-rate>
            </el-form-item>

            <el-form-item
              ref="isRecommend"
              :label="$t('User.label_text21')"
              prop="is_recommend"
              v-if="!isEdit || (UserInformation.is_recommend == 0 && isEdit)"
            >
              <el-radio-group
                v-model="form.is_recommend"
                @change="recommendChange"
              >
                <el-radio :label="1">{{ $t("User.recommend[0]") }}</el-radio>
                <el-radio
                  :label="0"
                  v-if="
                    !(
                      form.client_source == '转介绍' &&
                      form.channel_id == '107' &&
                      companyId === '8888'
                    )
                  "
                  >{{ $t("User.recommend[1]") }}</el-radio
                >
              </el-radio-group>
            </el-form-item>

            <el-form-item
              v-if="
                form.is_recommend == '1' &&
                (!isEdit || (isEdit && !UserInformation.re_parenter_mobile))
              "
              class="recommend-content"
            >
              <el-input
                v-model="form.recommend_keyword"
                style="width: 283px"
                @clear="searchRecomend"
                @input="$forceUpdate()"
                @keyup.enter.native="searchRecomend"
                :placeholder="$t('User.placeholder18')"
              >
                <i
                  slot="suffix"
                  @click="searchRecomend"
                  class="el-input__icon cur-pointer el-icon-search"
                ></i>
              </el-input>
              <el-button type="primary" size="large" @click="searchRecomend"
                >搜索</el-button
              >
              <!-- 弹出框 -->
              <div
                @click.stop
                v-if="recommendPopVisable"
                class="recommend-poplist"
              >
                <radioTableCont
                  :tableData="tableList"
                  @singleBox="singleBox"
                ></radioTableCont>
                <div class="pop__arrow"></div>
              </div>
            </el-form-item>
            <el-form-item
              v-if="form.is_recommend == '1'"
              :label="$t('User.label_text22')"
              prop="client_sponsor"
            >
              <div v-if="selecRecomInfo.student_cnname" class="recommend-info">
                {{ selecRecomInfo.student_cnname }}
                {{ selecRecomInfo.student_enname }}
                {{ selecRecomInfo.parenter_mobile }}
                <span></span>
                {{ $t("User.label_text23") }}{{ selecRecomInfo.school_cnname }}
              </div>
              <div v-else>{{ $t("User.tips") }}</div>
            </el-form-item>
            <!-- isCustomer判断是否为意向客户 -->
            <!-- <el-form-item v-if="isCustomer" label="客户状态：">
            <el-select filterable v-model="form.status" style="width: 358px;" placeholder="请选择客户状态">
              <el-option
                v-for="item in clientOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>-->
            <el-form-item
              v-if="
                form.client_source == '转介绍' &&
                form.channel_id == '107' &&
                companyId === '8888'
              "
              label="推荐教师"
              prop="client_teachername"
            >
              <el-select
                filterable
                v-model="form.client_teachername"
                clearable
                style="width: 358px"
                placeholder="请选择推荐教师"
                :disabled="!!UserInformation.client_teachername && isEdit"
              >
                <el-option
                  v-for="item in recommendTeacherList"
                  :key="item.marketer_id"
                  :label="item.marketer_name"
                  :value="item.staffer_cnname"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否为招生有效名单-->
            <el-form-item
              v-if="!isCustomer && !isEdit"
              :label="$t('User.label_text13')"
            >
              <el-select
                filterable
                v-model="form.main_marketer_id"
                style="width: 358px"
                clearable
                :placeholder="$t('User.placeholder13')"
                @change="changeMainFuMarket"
              >
                <el-option
                  v-for="(item, index) in main_chiefPerson"
                  :key="index"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 是否为意向客户 -->
            <el-form-item
              v-if="isCustomer && !isEdit"
              :label="$t('User.label_text13')"
              prop="main_marketer_id"
              class="tag-must"
            >
              <el-select
                filterable
                v-model="form.main_marketer_id"
                style="width: 358px"
                clearable
                :placeholder="$t('User.placeholder13')"
                @change="changeMainFuMarket"
              >
                <el-option
                  v-for="(item, index) in main_chiefPerson"
                  :key="index"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="!isEdit && company_isassist == 1"
              :label="$t('User.label_text14')"
            >
              <el-select
                filterable
                v-model="form.fu_marketer_id"
                style="width: 358px"
                multiple
                :placeholder="$t('User.placeholder14')"
              >
                <el-option
                  v-for="(item, index) in fu_chiefPerson"
                  :key="index"
                  :label="item.marketer_name"
                  :value="item.marketer_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="意向课程：">
            <el-select filterable v-model="form.class" style="width: 358px;" placeholder="请选择意向课程">
              <el-option label="类型一" value="类型一"></el-option>
              <el-option label="类型二" value="类型二"></el-option>
            </el-select>
          </el-form-item>-->
          </div>
          <p class="form-small-title h3">{{ $t("User.s_title5") }}</p>
          <div class="class-info">
            <el-form-item
              v-for="(item, index) in courseNum"
              :key="index"
              :label="item.title"
            >
              <el-select
                filterable
                v-model="item.coursecat_id"
                style="width: 358px"
                :label="$t('User.label_text15')"
                :placeholder="$t('User.placeholder15')"
                @change="disableCourseItem"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in courseList"
                  :key="item.coursecat_id"
                  :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                  :value="item.coursecat_id"
                ></el-option>
              </el-select>
              <span
                v-if="index"
                class="btn-delete"
                @click="ClickdeleteTwo(index)"
              >
                <i class="el-icon-remove-outline"></i>
              </span>
              <!-- 是否确认删除 -->
              <div
                v-if="index && isdelete2 && isdeleteindex2 == index"
                class="cofirm-delete"
              >
                <div class="delete-top">{{ $t("Common.tips") }}</div>
                <div class="delete-cont">
                  <p>{{ $t("Common.delTips") }}</p>
                </div>
                <div class="delete-footer">
                  <el-button
                    type="primary"
                    @click="deleteCourse(item, index)"
                    >{{ $t("Common.btn_confirm") }}</el-button
                  >
                  <el-button @click="handledeleteClose">{{
                    $t("Common.btn_cancel")
                  }}</el-button>
                </div>
              </div>
            </el-form-item>
            <div class="add-info">
              <span @click="addCourse">
                <i class="el-icon-circle-plus"></i>
                {{ $t("User.btn_text2") }}
              </span>
            </div>
          </div>
          <p class="form-small-title h3">{{ $t("User.s_title6") }}</p>
          <div class="inputclass-info">
            <el-form-item :label="$t('User.label_text16')">
              <el-input
                type="textarea"
                style="width: 358px"
                :placeholder="$t('User.placeholder16')"
                v-model="form.client_remark"
              ></el-input>
            </el-form-item>
          </div>
          <!-- <el-form-item>
          <el-button type="primary" @click="onSubmit">确认</el-button>
          <el-button @click="hideUserSliderBox()">取消</el-button>
        </el-form-item>-->
        </el-form>
      </div>
      <!-- 添加标签的弹框 -->
      <addTapPop
        v-if="addTagVisable"
        :dialogVisable="addTagVisable"
        :defautLabelList="form.client_tags"
        @handleCloseTip="addTagVisable = false"
        @handCancel="addTagVisable = false"
        @handConfirm="handConfirm"
      ></addTapPop>
    </div>
  </div>
</template>
<script>
import radioTableCont from "../../components/tables/radioTableCont";
import addTapPop from "./addTapPop";
import storeUser from "./User.js";
// import storeAdmissionCue from "../../views/Admissioncue/admissionCue.js";
export default {
  name: "userCreate",
  props: [
    "showUserSliderBox",
    "Userlist",
    "isCustomer",
    "clientOption",
    "SchoolsourceOption",
    "chiefPerson",
    "SchoolCourseOption",
    "isrepeat",
    "repeatList",
    "repeatData",
    "isEdit", //是否为编辑页面
    "UserInformation",
    "FamilyRelation",
  ],
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("User.rule_tips1")));
      } else {
        // const reg = /^(1(\d){10})$|^([09](\d){8})$/;
        let reg = "";
        if (this.$userinfo.language_type == "tw") {
          reg = /^09(\d){8}$/;
        } else {
          reg = /^1[3-9](\d){9}$/;
        }

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t("User.rule_tips2")));
        }
      }
    };
    var checkfamilyPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("User.rule_tips1")));
      } else {
        // const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        // const reg = /^1[3|4|5|6|7|8|9?][0-9]\d{8}$/;
        const reg = /^(1(\d){10})$|^([09](\d){8})$/;
        (() => {})(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error(this.$t("User.rule_tips2")));
        }
      }
    };
    // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var checkisCard = (rule, value, callback) => {
      const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      (() => {})(reg.test(value));
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error(this.$t("User.rule_tips3")));
      }
    };
    return {
      loading: false,
      showPromotionJobnumber: false,
      groundPromotionList: [],

      isClickChangeStudentType: false,
      addTagVisable: false, //添加标签
      currentDisabledIndex: -1,
      nearschoolList: [], //附近学校 select
      // 过滤后负责人下拉列表
      newMarketOptions: [],
      main_chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      familyNum: [
        {
          title: this.$t("User.label_text7"),
          family_relation: "",
          family_mobile: "",
          family_email: "",
          family_wechat: "",
          family_cnname: "",
          family_isdefault: "", //是否设置为主要联系人
          clickAdd: true,
        },
      ],
      family_radio: 0,
      courseNum: [
        {
          title: this.$t("User.label_text15"),
          coursecat_id: "",
        },
      ],
      ChannelOption: [], //招生渠道明细
      recordShow: false,
      isdelete: false,
      isdeleteindex: 0,
      isdelete2: false,
      isdeleteindex2: 0,
      errorTip1: ["0"],
      errorTip2: ["0"],
      companyId: "",
      Uploadimg: {
        company_id: "",
        ossfile: "",
      },
      imageUrl: "",
      // 男女图标
      womanImg: require("../../assets/images/icon/icon-person-women.png"),
      manImg: require("../../assets/images/icon/icon-person-men.png"),
      intention_level: null, //暂存意向星级
      intention_level_num: 5,
      num: 0,
      photoImg: require("../../assets/images/default-img.png"), //默认头像
      photoImgWomen: require("../../assets/images/default-img-women.png"), //默认女头像
      photoImgmen: require("../../assets/images/default-img-man.png"), //默认男头像
      photoImgDefaut: require("../../assets/images/default-img.png"), //默认头像
      form: {
        company_id: "",
        school_id: "",
        marketer_id: "",
        token: "",
        // activity_id: "",
        client_cnname: "",
        client_enname: "",
        client_img: "",
        // client_age: "",
        client_birthday: "",
        client_oh_month: "", //oh月
        client_push_month: "", //push月
        client_sex: "",
        client_mobile: "",
        client_icard: "",
        course_id: [],
        client_remark: "",
        main_marketer_id: "", //主负责人
        fu_marketer_id: [], //协助负责人
        client_fromtype: "0", //招生来源类型 *0是外部招生 1是内部招生
        client_source: "",
        channel_id: "",
        client_intention_level: "",
        is_recommend: "", //是否推荐名单
        client_teachername: "",
        recommend_keyword: "", //用来查询推荐人列表
        client_sponsor: "", //推荐人中文名
        client_stubranch: "", // 推荐人的编号
        family: [],
        nearschool_id: "", //附近学校id
        client_tags: [], //标签
        province_id: "", //省
        city_id: "", //市
        area_id: "", //区
        promotion_id: "",
      },
      provinceList: [], //省下拉列表
      cityList: [], //市下拉列表
      areaList: [], //区下拉列表
      intentionLevelList: [], //意向星级注释列表
      recommendPopVisable: false, //是否显示推荐人列表
      selecRecomInfo: {}, //选中的推荐人信息
      // 推荐人列表---表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          RadioSelect: true,
          errortip: "", //空页面提示内容
          tableHeight: "300px",
        },
      },
      // 表单验证
      rules: {
        client_cnname: [
          {
            required: true,
            message: this.$t("User.rule_tips4_1"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: this.$t("User.rule_tips4_2"),
            trigger: "blur",
          },
        ],
        // client_enname: [
        //   {
        //     required: true,
        //     message: this.$t("User.rule_tips5"),
        //     trigger: "blur"
        //   }
        // ],
        client_sex: [
          {
            required: true,
            message: this.$t("User.rule_tips6"),
            trigger: "change",
          },
        ],
        client_mobile: [{ validator: checkPhone, trigger: "blur" }],
        client_birthday: [
          {
            required: true,
            message: this.$t("User.rule_tips7"),
            trigger: "change",
          },
        ],
        main_marketer_id: [
          {
            required: true,
            message: this.$t("User.rule_tips8"),
            trigger: "change",
          },
        ],
        client_source: [
          {
            required: true,
            message: this.$t("User.rule_tips9"),
            trigger: "change",
          },
        ],
        channel_id: [
          {
            required: true,
            message: this.$t("User.rule_tips10"),
            trigger: "change",
          },
        ],
        promotion_id: [
          {
            required: true,
            message: "请输入地推工号",
            trigger: "change",
          },
        ],
        is_recommend: [
          {
            required: true,
            message: this.$t("User.rule_tips11"),
            trigger: "change",
          },
        ],
        client_teachername: [
          {
            required: true,
            message: "请选择推荐教师",
            trigger: "change",
          },
        ],
        client_sponsor: [
          {
            required: true,
            message: this.$t("User.rule_tips12"),
            trigger: "change",
          },
        ],
        // channel_id: [
        //   { required: true, message: this.$t("User.rule_tips10"), trigger: "change" }
        // ],
        family_mobile: [{ validator: checkfamilyPhone, trigger: "blur" }],
        client_icard: [{ validator: checkisCard, trigger: "blur" }],
        nearschool_id: [
          {
            required: false,
            message: this.$t("User.label_text18_4_ph"),
            trigger: "change",
          },
        ],
        province_id: [
          {
            required: true,
            message: this.$t("User.label_text18_5_ph1"),
            trigger: "change",
          },
        ],
        city_id: [
          {
            required: true,
            message: this.$t("User.label_text18_5_ph2"),
            trigger: "change",
          },
        ],
        area_id: [
          {
            required: true,
            message: this.$t("User.label_text18_5_ph3"),
            trigger: "change",
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      recommendTeacherList: [],
    };
  },
  watch: {
    // GetchiefPerson(n, o) {
    //   this.main_chiefPerson = n;
    //   this.fu_chiefPerson = n;
    // }
  },
  components: {
    radioTableCont,
    addTapPop,
  },
  created() {
    (() => {})(this.node);
    (() => {})(this.isEdit);
    (() => {})(this.UserInformation);
    (() => {})(this.familyNum);
    (() => {})(this.FamilyRelation, 12233);

    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.companyId = this.$store.state.COMPANY_ID;
    this.main_chiefPerson = this.chiefPerson;
    this.fu_chiefPerson = this.chiefPerson;
    // this.isrepeat=false;
    this.isdelete = false;
    this.Uploadimg = {
      company_id: this.companyId,
      // ossfile:""
    };
    if (this.isEdit) {
      let objForm = JSON.parse(JSON.stringify(this.UserInformation));
      objForm.client_tags = this.UserInformation.client_tag;
      this.form = objForm;

      this.remotePromotion(this.form.promotion_jobnumber);
      (() => {})(this.form, 11133333);
      if (this.UserInformation.client_family_list.length != 0) {
        this.familyNum = this.UserInformation.client_family_list;
        this.UserInformation.client_family_list.forEach((item, index) => {
          if (item.family_isdefault == "1") {
            this.family_radio = index;
            this.currentDisabledIndex = index;
          }
        });
      } else {
        this.familyNum = [
          {
            title: this.$t("User.label_text7"),
            family_relation: "",
            family_mobile: this.UserInformation.client_mobile || "",
            family_email: "",
            family_wechat: "",
            family_cnname: "",
            family_isdefault: "1", //是否设置为主要联系人
            clickAdd: true,
          },
        ];
      }
      // this.courseNum=this.UserInformation.intention_course;
      if (this.UserInformation.client_course_list.length != 0) {
        this.courseNum = this.UserInformation.client_course_list;
      }
      //默认头像显示
      if (this.UserInformation.client_img == "") {
        if (this.UserInformation.client_sex == "女") {
          this.photoImg = this.photoImgWomen;
        }
        if (this.UserInformation.client_sex == "男") {
          this.photoImg = this.photoImgmen;
        }
        if (this.UserInformation.client_sex == "") {
          this.photoImg = this.photoImgDefaut;
        }
      } else {
        this.photoImg = this.UserInformation.client_img;
      }
      this.selecRecomInfo = {
        student_cnname: this.form.client_sponsor,
        student_enname: this.form.student_enname,
        school_cnname: this.form.school_cnname,
        parenter_mobile: this.form.re_parenter_mobile,
      };
      this.levelTransform();
    } else {
      //重置
      this.photoImg = this.photoImgDefaut;
      this.form = {
        company_id: "",
        school_id: "",
        marketer_id: "",
        token: "",
        // activity_id: "",
        client_cnname: "",
        client_enname: "",
        client_img: "",
        // client_age: "",
        client_birthday: "",
        client_oh_month: "", //oh月
        client_push_month: "", //push月
        client_sex: "",
        client_mobile: "",
        client_icard: "",
        intention_course: [],
        client_remark: "",
        main_marketer_id: "", //主负责人
        fu_marketer_id: [], //协助负责人
        client_fromtype: "0", //招生来源类型 *0是外部招生 1是内部招生
        client_source: "",
        channel_id: "",
        client_intention_level: "",
        is_recommend: "", //是否推荐名单
        client_teachername: "",
        recommend_keyword: "", //用来查询推荐人列表
        client_sponsor: "", //推荐人中文名
        client_stubranch: "", // 推荐人的编号
        family: [],
        nearschool_id: "", //附近学校id
        client_tags: [], //标签
        province_id: "", //省
        city_id: "", //市
        area_id: "", //区
        promotion_id: "",
      };
    }
    this.recordShow = false;
    this.getChannelData(); //获取招生渠道明细
    this.getMarketer(); // 获取招生的负责人
    this.getNearSchoolApi(); // 获取学校 - 下拉
    this.getIntentionLevelList();
    this.getSchoolOneApi(); //通用->获取单个学校信息 -- 97
    this.getReMarketerApi();
  },
  computed: {
    isrepeatUser() {
      return this.isrepeat;
    },
    company_isassist() {
      return this.$store.state.companyIsassist;
    },

    courseList() {
      return this.SchoolCourseOption;
    },
    // GetchiefPerson() {
    //   return this.chiefPerson;
    // }
  },
  methods: {
    remotePromotion(query) {
      if (query) {
        this.loading = true;
        this.$http
          .getGroundPromotionApi({
            promotion_jobnumber: query,
          })
          .then((res) => {
            const { code, data: _jb } = res.data;

            const data = _jb;
            if (code === 200) {
              this.groundPromotionList = data.list;
            } else {
              this.groundPromotionList = [];
            }
            this.loading = false;
          });
      } else {
        this.groundPromotionList = [];
      }
    },
    emitShowRepeatList() {
      this.$emit("emitShowRepeatList");
    },
    modifyStudentType() {
      this.isClickChangeStudentType = true;
      // this.emitShowRepeatList()
      this.form.client_source = "转介绍";
      this.form.channel_id = "577";
      this.getChannelData();
    },
    handleClose(done) {
      this.$confirm(this.$t("Customersmanage.cb"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    getReMarketerApi() {
      storeUser.getReMarketerApi({}).then((res) => {
        if (res.data.code === 200) {
          this.recommendTeacherList = res.data.data.list;
        } else {
          this.recommendTeacherList = [];
        }
      });
    },
    disableCourseItem() {
      this.courseList.forEach((v1) => {
        v1.disabled = false;
        this.courseNum.forEach((v2) => {
          if (v1.coursecat_id == v2.coursecat_id) {
            v1.disabled = true;
          }
        });
      });
    },
    //招生有效名单->获取可选推荐人-lujing
    getClientStudentApi() {
      storeUser
        .getClientStudentApi({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          keyword: this.form.recommend_keyword, //渠道类型名称
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const data = body;
          this.tableList.columns = data.field;
          (() => {})(this.tableList.columns);
          if (code === 200) {
            this.tableList.list = data.list;
          } else {
            this.tableList.list = [];
          }
          this.tableList.options.errortip = msg;
          this.recommendPopVisable = true;
        });
    },
    // 公共->意向星级注释列表->zjc
    getIntentionLevelList() {
      this.$http.getIntentionLevelList({}).then((res) => {
        let list = res.data.data.list;
        let arr = [];
        list.forEach((e) => {
          arr.push(e.intentlevel_remark);
        });
        this.intentionLevelList = arr;
      });
    },
    // 检索推荐人
    searchRecomend() {
      if (this.form.recommend_keyword == "") {
        this.$message({
          message: this.$t("User.errorMessage1"),
          type: "error",
        });
      } else {
        this.getClientStudentApi(); //招生有效名单->获取可选推荐人-lujing
      }
    },
    hideUserSliderBox() {
      this.disableCourseItem();
      this.$emit("hideUserSliderBox");
    },
    // 选择主副负责人
    changChief(v) {
      // form.main_marketer_id
      // form.fu_marketer_id
      // chiefPerson
      let data = [];
      let _this = this;
      var allChief = this.chiefPerson.concat(this.fu_chiefPerson);
      allChief = Array.from(new Set(allChief));
      if (v == "main") {
        // 主负责人
        allChief.forEach((element) => {
          if (_this.form.main_marketer_id != element.marketer_id) {
            data.push(element);
          }
        });
        data = this.uniq(data);
        (() => {})(data);
        this.fu_chiefPerson = data;
        // this.$set(this.fu_chiefPerson,'e',data);
      } else {
        // 副负责人
        (() => {})(_this.form.fu_marketer_id);
        // allChief.forEach((element,index) => {
        //   _this.form.fu_marketer_id.forEach(element1 => {
        //     (() => {})(element.marketer_id,element1)
        //       if(element1==element.marketer_id){
        //         if(data.length>0){
        //           data.splice(index,1);
        //         }
        //       }else{
        //         data.push(element);
        //       }
        //     })

        // })

        for (var i = 0; i < _this.form.fu_marketer_id.length; i++) {
          for (var j = 0; j < allChief.length; j++) {
            if (allChief[j].marketer_id == _this.form.fu_marketer_id[i]) {
              allChief.splice(j, 1);
              j--;
            }
          }
        }
        data = this.uniq(allChief);
        this.main_chiefPerson = data;
      }

      (() => {})(this.main_chiefPerson);
    },
    // 数组去重
    uniq(array) {
      var temp = [];
      for (var i = 0; i < array.length; i++) {
        //如果当前数组的第i项在当前数组中第一次出现的位置是i，才存入数组；否则代表是重复的
        if (array.indexOf(array[i]) == i) {
          temp.push(array[i]);
        }
      }
      return temp;
    },
    // 新增时检测重名->我要跟踪
    trackRepeatClientAction(item_val) {
      this.$http
        .trackRepeatClientAction({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.companyId,
          school_id: this.school_id,
          client_id: item_val.client_id,
        })
        .then((res) => {
          //  if (res.data.code === 200) {
          //  }else{
          //    this.$message({
          //     message: res.data.msg,
          //     type: "error"
          //   });
          //  }
          this.$emit("wantToTrack", item_val);
        });
    },
    //获取招生渠道明细
    getChannelData() {
      this.$http
        .getChannel({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id,
          channel_medianame: this.form.client_source, //渠道类型名称
          fixed_channel_id: this.isEdit ? this.UserInformation.channel_id : "",
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.ChannelOption = res.data.data.list;
          // this.ChannelOption.unshift({
          //   channel_id: "",
          //   channel_name: "不限"
          // });

          if (this.isEdit) {
            let list = this.ChannelOption.filter(
              (v) => v.channel_id == this.form.channel_id
            );
            this.showPromotionJobnumber = list[0].channel_push == 1;
          }
        });
    },
    // 获取招生的负责人
    getMarketer() {
      this.$http
        .getMarketer({
          main_marketer_id: this.form.main_marketer_id,
          is_drop: "0", //是否过滤 已离职人员0 过滤 1不过滤
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          // this.chiefPerson = res.data.data.list;
          if (this.form.main_marketer_id == "") {
            this.main_chiefPerson = res.data.data.list;
          }
          this.fu_chiefPerson = res.data.data.list;
        });
    },
    // 选择主副负责人
    changeMainFuMarket() {
      this.getMarketer(); // 获取招生的负责人
    },
    // 选择招生渠道类型
    selectSource() {
      this.getChannelData(); //获取招生渠道明细
      this.form.channel_id = "";
    },
    //通用->获取单个学校信息 -- 97
    getSchoolOneApi() {
      this.$http.getSchoolOneApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          if (!this.isEdit) {
            const row = Array.isArray(data) ? data[0] : (data.list && data.list[0]) || data;
            this.form.province_id = row.school_province
              ? row.school_province.toString()
              : "";
            this.form.city_id = row.school_city
              ? row.school_city.toString()
              : "";
            this.form.area_id = row.school_area
              ? row.school_area.toString()
              : "";
          }
        }

        this.getProvinceData(); // 获取省份
        if (this.form.province_id != "") {
          this.getCityData();
        }
        if (this.form.city_id != "") {
          this.getAreaApi();
        }
      });
    },
    // 获取省份
    getProvinceData() {
      this.$http.getProvince({}).then((res) => {
        // (() => {})(res.data.data.data)
        this.provinceList = res.data.data.data;
      });
    },
    // 获取城市
    getCityData() {
      this.$http
        .getCity({
          region_id: this.form.province_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.data)
          this.cityList = res.data.data.data;
        });
    },
    // 获取区域
    getAreaApi() {
      this.$http
        .getAreaApi({
          region_id: this.form.city_id,
        })
        .then((res) => {
          // (() => {})(res.data.data.data)
          this.areaList = res.data.data.data;
        });
    },
    // 选择省
    changeProvince() {
      this.form.city_id = "";
      this.form.area_id = "";
      this.areaList = [];
      this.getCityData();
    },
    // 选择市
    changeCity() {
      this.form.area_id = "";
      this.getAreaApi();
    },
    //意向星级转换
    levelTransform() {
      this.num = parseInt(this.UserInformation.client_intention_level);
      (() => {})(this.num);
    },
    onChangeChannelId() {
      if (
        this.form.client_source == "转介绍" &&
        this.form.channel_id == "107" &&
        this.form.is_recommend === 0
      ) {
        this.form.is_recommend = "";
        this.$nextTick(() => {
          this.$refs.isRecommend.clearValidate();
        });
      }

      let list = this.ChannelOption.filter(
        (v) => v.channel_id == this.form.channel_id
      );
      this.showPromotionJobnumber = list[0].channel_push == 1;
    },
    // 意向星级点击
    handClickLevel() {
      // this.intention_levelmax=this.intention_level.length;
      var max = 0;
      this.intention_level.forEach((element) => {
        if (max < parseInt(element)) {
          max = element;
        }
      });
      this.intention_levelmax = max;
    },
    recordHide() {
      this.recordShow = true;
    },
    // 确定要选择的标签
    handConfirm(val) {
      if (val.length > 0) {
        this.form.client_tags = [];
        val.forEach((e) => {
          this.form.client_tags.push(e.label_name);
        });
      }
      this.addTagVisable = false;
    },
    onSubmit() {
      let v;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            this.form.client_intention_level = this.num;
          } else {
            this.form.client_intention_level = this.intention_level;
          }
          v = this.form;

          (() => {})(this.familyNum, "this.familyNum");
          (() => {})(this.courseNum, "this.courseNum");
          // 去除title
          this.familyNum.forEach((item, index) => {
            delete item.title; //删除属性
            (() => {})(index, this.family_radio);
            if (index == this.family_radio) {
              item.family_isdefault = "1";
            } else {
              item.family_isdefault = "0";
            }
          });

          (() => {})(this.familyNum, "this.familyNum -- this.familyNum");

          if (
            this.familyNum.some(
              (item) =>
                /*!item.family_cnname ||
                !item.family_relation ||
                !item.family_mobile*/
                !item.family_mobile
            )
          ) {
            // this.$message.error("请填写家庭联系人姓名、关系和手机号");
            this.$message.error("请填写家庭联系人手机号");
            return false;
          }

          let reg = "";
          if (this.$userinfo.language_type == "tw") {
            reg = /^09(\d){8}$/;
          } else {
            reg = /^1[3-9](\d){9}$/;
          }
          if (this.familyNum.some((value) => !value.family_mobile)) {
            this.$message.error("家庭联系信息手机号必填");
            return false;
          } else if (
            !this.familyNum.every((value) => reg.test(value.family_mobile))
          ) {
            this.$message.error("家庭联系信息手机号格式不正确");
            return false;
          }

          this.courseNum.forEach((item) => {
            delete item.title; //删除属性
          });
          let labelList = [];
          // this.form.client_tags.forEach((item) => {
          //   labelList.push({
          //     label_id: item.label_id,
          //   });
          // });
          this.form.client_tags.forEach((item) => {
            labelList.push(item);
          });
          v.client_family_list = this.familyNum;
          v.intention_course = this.courseNum;
          v.label_list = JSON.stringify(labelList);

          delete v.client_wechat;
          this.$emit("onSubmit", v);
        } else {
          (() => {})("error submit!!");
          return false;
        }
      });
      // this.form.client_img = this.imageUrl;
    },
    // 中文名手机号验证
    checkIntentionClientData(val) {
      if (this.checkTimer) {
        clearTimeout(this.checkTimer);
      }
      this.checkTimer = setTimeout(() => {
        this.$emit("checkIntentionClientData", val); // 新增时检测重名->我要跟踪
      }, 500);
    },
    // 我要跟踪
    wantToTrack(v) {
      this.trackRepeatClientAction(v);
    },
    addFamily() {
      // this.familyNum.push("");
      var family = {
        title: "",
        family_relation: "",
        family_mobile: "",
        family_email: "",
        family_wechat: "",
        family_cnname: "",
        family_isdefault: 0,
        clickAdd: true,
      };
      this.familyNum.push(family);
      // this.errorTip1.push("0");
      // this.errorTip2.push("0");
    },
    // 验证家庭信息的手机号
    checkPhoneNumber(val, key) {
      (() => {})(key);
      (() => {})(this.errorTip1[key]);
      if (val == "") {
        this.errorTip1[key] = "1";
        this.errorTip2[key] = "0";
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        (() => {})(reg.test(val));
        if (reg.test(val)) {
          this.errorTip1[key] = "0";
          this.errorTip2[key] = "0";
        } else {
          this.errorTip1[key] = "0";
          this.errorTip2[key] = "1";
        }
      }
      (() => {})(this.errorTip1[key]);
    },
    // 删除家庭信息
    deleteFamily(item, key) {
      this.familyNum.splice(key, 1);
      this.isdelete = false;
      if (this.familyNum.length == 1) {
        this.familyNum[0]["family_isdefault"] = 1;
      }
      this.$emit("deleteFamily", item);
    },
    addCourse() {
      var course = {
        title: "",
        coursecat_id: "",
      };
      this.courseNum.push(course);
    },
    // 删除意向课程
    deleteCourse(item, key) {
      this.courseNum.splice(key, 1);
      this.isdelete2 = false;
      this.disableCourseItem();
      this.$emit("deleteCourse", item);
    },
    // 输入手机号
    InputPhone() {
      let phone = this.form.client_mobile;
      this.familyNum.forEach((item, index) => {
        if (index == this.family_radio) {
          item.family_mobile = phone;
        }
      });
      // if (this.isEdit) {
      //   this.familyNum.forEach((item, index) => {
      //     if (index == this.family_radio) {
      //       item.family_mobile = phone;
      //     }
      //   });
      // } else {
      //   this.familyNum.forEach((item, index) => {
      //     if (index == this.family_radio) {
      //       item.family_mobile = phone;
      //     }
      //   });
      // }
    },
    BlurPhone () {
      // let phone = this.form.client_mobile;
      // this.familyNum.forEach((item, index) => {
      //   if (index == this.family_radio) {
      //     item.family_mobile = phone;
      //   }
      // }); 
    },
    handledeleteClose() {
      this.isdelete = false;
      this.isdelete2 = false;
    },
    Clickdelete(k) {
      this.isdelete = true;
      this.isdeleteindex = k;
    },
    ClickdeleteTwo(k) {
      this.isdelete2 = true;
      this.isdeleteindex2 = k;
    },
    // 选择是否推荐名单
    recommendChange() {
      this.form.recommend_keyword = "";
      this.form.client_sponsor = "";
      this.form.client_stubranch = "";
      this.selecRecomInfo = {};
    },
    // 单选框
    singleBox(val) {
      this.selecRecomInfo = val;
      this.recommendPopVisable = false;
      this.form.client_sponsor = val.student_cnname;
      this.form.client_stubranch = val.student_branch;
    },
    // 头像上传的方法
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code === 200) {
        this.form.client_img = res.data.picture_imgurl;
      }
      (() => {})(res);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isImg = isJPG || isPNG || isGIF;

      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error(this.$t("User.message_tips"));
      }

      return isImg;
    },
    // 获取学校 - 下拉
    getNearSchoolApi() {
      this.$http
        .getNearSchoolApi({
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.nearschoolList = res.data.data.list;
          } else {
            this.nearschoolList = [];
          }
        });
    },
  },
};
</script>
<style lang="less">
.silder-contain .slider-create-edit {
  padding: 0px !important;
  // 推荐人信息
  .recommend-info {
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      width: 1px;
      height: 20px;
      margin: 0 10px;
      background: rgba(223, 223, 223, 1);
    }
  }
  .recommend-content {
    position: relative;
    .recommend-poplist {
      position: absolute;
      left: 0;
      top: 50px;
      background: #fff;
      z-index: 300;
      min-width: 335px;
      max-width: 600px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      // padding: 12px;
      color: #606266;
      font-size: 14px;
      line-height: 23px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      .pop__arrow,
      .pop__arrow:after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
      }
      .pop__arrow {
        top: -6px;
        left: 35%;
        margin-right: 3px;
        border-top-width: 0;
        border-bottom-color: #ebeef5;
      }
      .pop__arrow:after {
        top: 1px;
        margin-left: -6px;
        border-top-width: 0;
        border-bottom-color: #fff;
      }
    }
  }
  .select-city {
    margin: 0 10px;
  }
  // 标签样式
  .form-item-tag {
    .el-form-item__content {
      display: flex;
    }
    .tag-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      width: 358px;
      padding-top: 4px;
      .tagItem {
        text-align: center;
        display: block;
        min-width: 80px;
        height: 28px;
        line-height: 28px;
        border-radius: 15px;
        color: #28abd9;
        font-size: 14px;
        padding: 0 18px;
        border: 1px solid #28abd9;
        margin-right: 20px;
        margin-bottom: 10px;
      }
    }
    .addTagBtn {
      color: #28abd9;
      cursor: pointer;
      line-height: 38px;
    }
  }
}
// 家庭信息错误提示样式
.family-error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  // margin-left: 41%;
}
//意向星级样式
.client-level {
  .el-checkbox-group {
    display: inline-block;
  }
  .el-checkbox {
    position: relative;
    .el-checkbox__input {
      opacity: 0;
    }
  }
  .el-checkbox + .el-checkbox {
    margin-left: 0px;
  }
  .el-icon-star-off {
    position: absolute;
    top: 7px;
    left: 0px;
    color: #f56c6c;
    font-size: 18px;
  }
  .is-checked .el-checkbox__label .el-icon-star-off:before {
    content: "\E637";
  }
}
.el-form-item--medium .el-form-item__content .el-rate {
  height: 40px;
  line-height: 40px;
  i {
    line-height: 40px;
  }
}
.el-form-item--medium .el-form-item__content .el-rate i {
  color: #ff8a00 !important;
}
.sliderBox .silder-contain .slider-person-info .person-img {
  .el-upload {
    width: 52px;
    height: 52px;
    // position: absolute;
    // left: 20px;
    // top: 15px;
    display: inline-block;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
//上传头像按钮样式
.sliderBox .silder-contain .slider-person-info {
  .btn-upload {
    position: relative;
    .btn-avatar-uploader {
      width: 75px;
      height: 24px;
      position: absolute;
      left: 0px;
      top: 0px;
      opacity: 0;
      .avatar {
        width: 75px;
        height: 24px;
        img {
          width: 75px;
          height: 24px;
        }
      }
    }
  }
}
.btn-upload input {
  cursor: pointer;
}
.btn-upload span {
  cursor: pointer;
}
.btn-delete {
  display: inline-block;
  margin-left: 10px;
  font-size: 20px;
  color: rgba(204, 204, 204, 1);
  cursor: pointer;
}
.add-info {
  position: relative;
  padding-left: 25px;
  height: 26px;
  line-height: 26px;
  i {
    position: absolute;
    top: 3px;
    left: 0px;
    font-size: 20px;
  }
}
.error-tip {
  color: rgba(208, 2, 27, 1);
  display: inline-block;
  height: 26px;
  line-height: 26px;
  margin-left: 20px;
  padding-right: 30px;
  position: relative;
  i {
    font-size: 20px;
    display: inline-block;
    position: absolute;
    top: 3px;
    cursor: pointer;
    right: 0px;
  }
}
.pop-container--form {
  position: relative;
  .repeat-record {
    width: 320px;
    position: absolute;
    background: #fff;
    z-index: 500;
    top: 48%;
    right: 10px;
    min-height: 300px;
    padding-bottom: 20px;
    border-radius: 4px;
    border: 1px solid #ddd;
    max-height: 400px;
    overflow-y: auto;
    .record-top {
      border-bottom: 1px solid #ddd;
      span {
        display: inline-block;
        height: 40px;
        line-height: 40px;
      }
      .btn-close {
        height: 40px;
        line-height: 40px;
        margin-left: 20px;
        cursor: pointer;
      }
    }
    .record-cont {
      .record-item {
        border: 1px solid #ddd;
        border-radius: 3px;
        padding: 10px;
        margin-top: 20px;
        .small-tip {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        p {
          height: 25px;
          line-height: 25px;
          span {
            display: inline-block;
            margin-right: 8%;
          }
          .tip-school {
            margin-right: 0%;
          }
          .btn-track {
            width: 74px;
            height: 22px;
            line-height: 22px;
            // background: rgba(39, 170, 216, 1);
            background: #ddd;
            border-radius: 3px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            margin-right: 0%;
          }
          .btn-track-active {
            background: rgba(39, 170, 216, 1);
            &.disabled {
              background-color: #999;
            }
          }
          .name {
            position: relative;
            padding-right: 30px;
            color: #20a8d8;
            img {
              position: absolute;
              right: 2px;
              top: 2px;
            }
          }
        }
      }
    }
    > div {
      padding: 0px 20px;
    }
  }
}
.family-info,
.class-info {
  .el-form-item {
    position: relative;
    .cofirm-delete {
      position: absolute;
      top: 40px;
      right: 100px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px;
      border: 1px solid rgba(221, 221, 221, 1);
      z-index: 200;
      > div {
        padding: 10px 20px;
      }
      .delete-top {
        line-height: 30px;
        padding: 0px 20px;
        background: rgba(238, 238, 238, 1);
        border-bottom: 1px solid rgba(221, 221, 221, 1);
      }

      .delete-footer {
        .el-button + .el-button {
          margin-left: 32px !important;
        }
      }
    }
  }
}
// 家庭信息样式
.family-info {
  .f-label-title {
    display: inline-block;
    width: 100px;
    line-height: 36px;
    text-align: right;
    color: #55606e;
    padding: 0 12px 0 0;
  }

  .family-list-info {
    display: inline-block;
    position: relative;
    font-size: 14px;
    line-height: 36px;
    // width:100%;
    // 默认单选按钮样式
    .isdefault {
      margin-left: 10px;
      .el-radio__inner {
        width: 18px;
        height: 18px;
        border: 1px solid #20a8d8;
      }
      .el-radio__input.is-checked .el-radio__inner {
        width: 18px;
        height: 18px;
        background: #fff;
      }
      .el-radio__inner::after {
        background: #20a8d8;
        width: 6px;
        height: 6px;
      }
      .el-radio__original {
        width: 18px;
        height: 18px;
      }
    }
    .el-form-item__error {
      position: absolute;
    }
    .el-form-item {
      display: inline-block;
      width: 110px;
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
    .name {
      width: 140px;
      margin: 0px 10px;
    }
    .mobile {
      width: 140px;
    }
  }

  .cofirm-delete {
    position: absolute;
    top: 40px;
    right: -10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    border: 1px solid rgba(221, 221, 221, 1);
    z-index: 200;
    > div {
      padding: 10px 20px;
    }
    .delete-top {
      line-height: 30px;
      padding: 0px 20px;
      background: rgba(238, 238, 238, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
    }
    .delete-footer {
      .el-button + .el-button {
        margin-left: 32px !important;
      }
    }
  }
}
</style>
<style lang="less">
.rate-startLevel-diy {
  position: relative;
  .el-rate__text {
    font-size: 12px;
    position: absolute;
    width: 100%;
    bottom: -10px;
    left: 0;
    line-height: 100%;
  }
}
</style>
